import React from 'react';
import { Info, Ruler } from 'lucide-react';
import { useFormContext } from '../FormContext';
import { FormStep } from '../FormStep';
import { InfoBox } from '../InfoBox';
import { FormButtons } from '../FormButtons';
export const SchuttingDetailsStep: React.FC = () => {
  const {
    formData,
    handleChange,
    goToPreviousStep,
    goToNextStep
  } = useFormContext();
  return <FormStep title="Schutting details" description="Geef de afmetingen van de gewenste schutting aan." isActive={true} data-id="element-1144">
      <div className="space-y-6 mb-10" data-id="element-1145">
        <div data-id="element-1146">
          <label className="block text-white/90 font-medium mb-2" data-id="element-1147">
            Lengte (cm) *
          </label>
          <div className="relative" data-id="element-1148">
            <input type="text" inputMode="numeric" value={formData.schuttingLength} onChange={handleChange} name="schuttingLength" placeholder="Bijv. 600" className="w-full px-4 py-3 rounded-md border border-white/30 bg-white/10 focus:outline-none focus:ring-2 focus:ring-[#CDA735] focus:border-transparent text-white placeholder-white/50" data-id="element-1149" />
            <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none" data-id="element-1150">
              <Ruler className="h-5 w-5 text-white/50" data-id="element-1151" />
            </div>
          </div>
        </div>
        <div data-id="element-1152">
          <label className="block text-white/90 font-medium mb-2" data-id="element-1153">
            Hoogte (cm) *
          </label>
          <div className="relative" data-id="element-1154">
            <input type="text" inputMode="numeric" value={formData.schuttingHeight} onChange={handleChange} name="schuttingHeight" placeholder="Bijv. 180" className="w-full px-4 py-3 rounded-md border border-white/30 bg-white/10 focus:outline-none focus:ring-2 focus:ring-[#CDA735] focus:border-transparent text-white placeholder-white/50" data-id="element-1155" />
            <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none" data-id="element-1156">
              <Ruler className="h-5 w-5 text-white/50" data-id="element-1157" />
            </div>
          </div>
        </div>
        <div data-id="element-1158">
          <label className="block text-white/90 font-medium mb-2" data-id="element-1159">
            Extra opmerkingen (optioneel)
          </label>
          <textarea value={formData.schuttingRemarks} onChange={handleChange} name="schuttingRemarks" rows={3} placeholder="Bijv. materiaalvoorkeur, speciale wensen, etc." className="w-full px-4 py-3 rounded-md border border-white/30 bg-white/10 focus:outline-none focus:ring-2 focus:ring-[#CDA735] focus:border-transparent text-white placeholder-white/50" data-id="element-1160" />
        </div>
      </div>
      <InfoBox icon={<Info data-id="element-1162" />} data-id="element-1161">
        Verdere details over materialen, type schutting en afwerking zullen
        telefonisch met u worden besproken.
      </InfoBox>
      <FormButtons onPrevious={goToPreviousStep} onNext={goToNextStep} isNextDisabled={!formData.schuttingLength || !formData.schuttingHeight} data-id="element-1163" />
    </FormStep>;
};